import React from "react";
import Table from "../../../../shared/table";
import moment from "moment";
import Button from "../../../../shared/button";
import { useGetAllReservationsEmailMutation, useGetOutlookCredentialsQuery } from "../../../../store/google-reservations/googleReservationsApi";
import { useGetCurrentAuthUrlQuery } from "../../../../store/reservations/reservationsApi";

const tableColumns = ["Sent from", "Email Sent at"];

const ReservationsEmails = () => {
	const { data: authUrl }= useGetCurrentAuthUrlQuery({});
	const { data: outlookCredentials } =
    useGetOutlookCredentialsQuery();
  const [getAllReservations, { isLoading, data, error }] =
    useGetAllReservationsEmailMutation();

  const handleGetAllReservations = async () => {
	const {accessToken, refreshToken} = outlookCredentials || {};
	localStorage.setItem('googleAccessToken', accessToken || '')
	localStorage.setItem('googleRefreshToken', refreshToken || '')
	if (accessToken) {
		await getAllReservations(accessToken || "").unwrap();
	} else {
		window.location.assign(authUrl.authUrl)
	}
  };

  const rows = [data];
  const errorObj = error as { data: { message: string } };
  return (
    <div className="bg-white p-4">
      <h2 className="text-[#5D6679] text-base mb-2">Reservation E-mails</h2>
      <div className="bg-[#F9F9F9] rounded-lg px-4 py-6">
        <div className="flex flex-row items-center">
          <img src="/assets/shared/email.svg" alt="" />
          <div className="ml-3">
            <p className="text-[#161048] text-xs">
              Last Processing -{" "}
              {typeof data?.date === "object" && moment(data?.date).fromNow()}
            </p>
            <h4 className="text-[#202020] text-base font-bold">New Emails</h4>
            <p className="text-primary-default text-base">
              {data?.totalEmailsProcessed}
            </p>
          </div>
        </div>
        <Button
          icon={
            <img
              alt="review"
              className="mr-2"
              src="/assets/shared/reviewt.svg"
            />
          }
          onClickButton={handleGetAllReservations}
          label="Review Reservation Emails"
          loading={isLoading}
          className="mt-3 bg-saloon-btn rounded-xl py-2 px-4 text-white flex flex-row items-center text-sm md:tex-base"
        />
      </div>
      <Table columns={tableColumns} hidePagination>
        {isLoading ? (
          <>
            {[...Array(4)].map((x, i) => {
              return (
                <tr key={i}>
                  {[...Array(tableColumns?.length || 1)].map((x, j) => {
                    return (
                      <td
                        key={j}
                        className="td-1 !min-w-[100%] text-center py-5"
                      >
                        <span></span>
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </>
        ) : (
          <>
            {rows?.length > 0 &&
              rows?.map((row, idx: number) => {
                return row?.emails ? (
                  <tr key={idx} className="bg-white border-b hover:bg-gray-50">
                    <td className="px-5 py-4">
                      {row?.emails && Object.keys(row?.emails)[0]}
                    </td>
                    <td className="px-5 py-4">
                      {row?.email &&
                        row?.emails[Object.keys(row?.emails)[0]][0]}
                      {/* {moment(row?.updatedAt).format("DD/MM/YYYY HH:mm")} */}
                    </td>
                  </tr>
                ) : (
                  <tr>
                    <td className="px-5 py-4" colSpan={2}>
                      {errorObj?.data?.message || data?.message || "No unread emails found"}
                    </td>
                  </tr>
                );
              })}
          </>
        )}
      </Table>
    </div>
  );
};

export default ReservationsEmails;
